import React from 'react';

const formatDate = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleDateString('en-US'); // MM/DD/YYYY
};

const ArticleModal = ({ show, article, onClose }) => {
  if (!show || !article) return null;

  return (
    <div className="modal show d-block modal-overlay-dark" tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{article.title} ({article.source})</h5>
            <button 
              type="button" 
              className="modal-close-button" 
              onClick={onClose}
              aria-label="Close"
            >
              <i className="fas fa-times"></i>
            </button>
          </div>
          <div className="modal-body">
            <p><strong>Author:</strong> {article.author || 'Unknown'}</p>
            <p><strong>Date:</strong> {formatDate(article.date)}</p>
            {article.url && (
              <p><strong>Source:</strong> <a href={article.url} target="_blank" rel="noopener noreferrer">{article.url}</a></p>
            )}
            <div className="mt-3">
              <strong>Article Content:</strong>
              <div className="mt-2 p-2 border rounded bg-white preformatted-text">
                {article.full_text || 'No article text available.'}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleModal;